export default "__VITE_ASSET__D8GjZ3Bf__"